import { AxiosResponse, ipmQueryClient, referralsSplit } from '@ukpostbox/client-data';
import { IpmRqKeys } from '@ukpostbox/client-data/lib/Wrappers/ReactQuery/CacheKeys';
import {
	ButtonSubmit,
	ColourStateSolid,
	ComboBoxControl,
	ComboBoxItemDisplayEnum,
	ComboBoxTypeEnum,
	Modal,
	ModalType,
	useTranslation,
} from '@ukpostbox/frontend-framework';
import { FormProvider, useForm } from '@ukpostbox/frontend-framework/lib/ReactHookForm';
import React, { useState } from 'react';
import { ErrorMapper } from '../../../../_Global/Components/ErrorMapper';

interface ChangeSplitModalType extends ModalType {
	currentSplit: number;
}

function ChangeSplitModal(props: ChangeSplitModalType) {
	const { t } = useTranslation();

	const [splitError, setSplitError] = useState<AxiosResponse>();

	const formMethods = useForm({
		defaultValues: {
			split: props.currentSplit,
		},
		mode: 'onChange',
	});

	const { handleSubmit, setValue, reset, formState } = formMethods;

	const HandleSplitChange = (data: any) => {
		referralsSplit(data.split)
			.then((r) => {
				props.closeCallback();
				ipmQueryClient.invalidateQueries({ queryKey: [IpmRqKeys.REFERRALS_SUMMARY] }).then(() => null);
			})
			.catch((e) => {
				setSplitError(e);
			});
	};

	return (
		<Modal title={t('settings.referralsSplit.title')} isOpen={props.isOpen} closeCallback={props.closeCallback}>
			<FormProvider {...formMethods}>
				<form onSubmit={handleSubmit(HandleSplitChange)}>
					<fieldset className='flex-column flex-gap-md'>
						{splitError?.data && <ErrorMapper errorResponse={splitError} />}

						<ComboBoxControl
							name='split'
							placeholder={t('settings.referralsSplit.controls.splitPlaceholder')}
							valueType='number'
							displayType={ComboBoxTypeEnum.Single}
							displayItemLabelType={ComboBoxItemDisplayEnum.Label}
							forwardValueCallback={(e) => setValue('split', e)}
							data={[
								{
									label: '0%',
									value: 0,
								},
								{
									label: '25%',
									value: 25,
								},
								{
									label: '50%',
									value: 50,
								},
								{
									label: '75%',
									value: 75,
								},
								{
									label: '100%',
									value: 100,
								},
							]}
							defaultValue={props.currentSplit ? [props.currentSplit] : undefined}
						/>

						<ButtonSubmit
							title={t('settings.referralsSplit.actions.save')}
							colour={ColourStateSolid.Primary}
							fullWidth
							disabled={!formState.isValid || formState.isSubmitting}
						/>
					</fieldset>
				</form>
			</FormProvider>
		</Modal>
	);
}

export default ChangeSplitModal;
